import type { FullAudit } from '~/constants/auditTypes'
import type { User } from '~/constants/userTypes'
import apiUtil, { throwApiError } from '~/utils/apiUtils'

const { get, patch, del } = apiUtil()

class UserAPI {
  constructor() {}

  async getUser(): Promise<any> {
    try {
      const response = await get('/user')

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error getting user:', error)
      throw error
    }
  }

  async updateUser(user: Partial<User>): Promise<any> {
    try {
      const response = await patch(`/user/update`, user)

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}))
        const errorMessage = errorData.error || `HTTP error! status: ${response.status}`
        throw new Error(errorMessage)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error updating user:', error)
      throw error
    }
  }

  async deleteAccount(): Promise<void> {
    try {
      const response = await del('/auth/delete')

      if (!response.ok) {
        // throwApiError preserves the backend code+message on err.response.data
        // so callers can branch on e.g. ownership_transfer_required.
        await throwApiError(response)
      }

      return await response.json()
    } catch (error) {
      console.error('Error deleting account:', error)
      throw error
    }
  }
}

const userApi = new UserAPI()

export default userApi
